import {useQuery} from "@tanstack/react-query";
import {QueryKeys} from "@/Service/Api/V1/QueryKeys/QueryKeys";
import {GtaRatesApiClient} from "@/Service/Api/V1/ApiClients/GtaRatesApiClient";

export type useGetGtaRateConfigParams = {
    enabled?: boolean
};

export const useGetGtaRateConfig = ({enabled}: useGetGtaRateConfigParams) => useQuery({
    ...QueryKeys.gtaRates.config(),
    queryFn: async () => await GtaRatesApiClient.getGtaConfig(),
    enabled,
    retry: false
});